// LUMINA · pages/CommunityPage.jsx
// 法道社群 — 订阅法讯 + 近期法会
// Sacred Tech: dark green #064E3B + gold #D4AF37 + dark red #8B1A1A

import React, { useState, useEffect } from 'react';

const API = "/api";
const DR = "#8B1A1A";   // dark red
const DG = "#064E3B";   // dark green
const GD = "#D4AF37";   // gold
const BG = "#F9F7F2";   // sacred white
const PANEL = "rgba(255,255,255,0.82)";

export default function CommunityPage({ setPage }) {
  const [events, setEvents] = useState([]);
  const [expandedEvent, setExpandedEvent] = useState(null);

  useEffect(() => {
    fetch(`${API}/dharma/events`)
      .then(r => r.ok ? r.json() : [])
      .then(d => setEvents(d.slice(0, 3)))
      .catch(() => {});
  }, []);

  return (
    <div style={{ minHeight: "100vh", background: BG, fontFamily: "'Noto Serif SC', 'Noto Serif', serif" }}>

      {/* Header */}
      <div style={{ background: DG, padding: "48px 24px 40px", textAlign: "center", position: "relative" }}>
        <div style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(0,0,0,0.12)", pointerEvents: "none" }} />
        <div style={{ position: "relative" }}>
          <div style={{ color: GD, fontSize: 32, letterSpacing: 6, marginBottom: 10 }}>法道社群</div>
          <div style={{ color: "rgba(255,255,255,0.65)", fontSize: 14, letterSpacing: 2 }}>佛法因缘 · 共修护持 · 法讯传递</div>
          <div style={{ width: 48, height: 1, background: GD, margin: "20px auto 0", opacity: 0.6 }} />
        </div>
        {setPage && (
          <button
            onClick={() => setPage("landing")}
            style={{ position: "absolute", top: 16, left: 16, background: "none", border: "none", color: "rgba(255,255,255,0.4)", fontSize: 13, cursor: "pointer" }}
          >← 返回</button>
        )}
      </div>

      <div style={{ maxWidth: 680, margin: "0 auto", padding: "40px 20px 80px" }}>

        {/* Subscribe CTA — redirects to /vajra/subscribe (Phase 123: unified entry) */}
        <div style={{ background: PANEL, border: `1px solid rgba(139,26,26,0.15)`, borderRadius: 14, padding: "32px 32px", marginBottom: 40, backdropFilter: "blur(12px)", textAlign: "center" }}>
          <div style={{ fontSize: 18, color: DR, letterSpacing: 2, marginBottom: 12 }}>订阅法讯</div>
          <div style={{ fontSize: 13, color: "#888", marginBottom: 20, lineHeight: 1.8 }}>
            订阅后将收到法会通知、共修安排及重要法讯。<br />
            选择您感兴趣的传承，精准接收相关法讯。
          </div>
          <a
            href="/vajra/subscribe"
            style={{
              display: "inline-block", padding: "12px 32px",
              background: DR, color: "#fff", borderRadius: 8,
              fontSize: 16, letterSpacing: 2, textDecoration: "none",
            }}
          >前往订阅 →</a>
        </div>

        {/* Recent Events */}
        {events.length > 0 && (
          <div>
            <div style={{ fontSize: 18, color: DG, letterSpacing: 2, marginBottom: 20, textAlign: "center" }}>近期法会因缘</div>
            {events.map(ev => (
              <div
                key={ev.id}
                style={{ background: PANEL, border: `1px solid rgba(6,78,59,0.15)`, borderRadius: 12, padding: "20px 24px", marginBottom: 16, backdropFilter: "blur(12px)", cursor: "pointer" }}
                onClick={() => setExpandedEvent(expandedEvent === ev.id ? null : ev.id)}
              >
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                  <div>
                    <div style={{ fontSize: 16, color: "#2d2d2d", marginBottom: 4 }}>{ev.title_zh || ev.title_en}</div>
                    <div style={{ fontSize: 13, color: "#888" }}>{ev.teacher_zh || ev.teacher_en} · {ev.location}</div>
                  </div>
                  <div style={{ fontSize: 18, color: DG, marginLeft: 12 }}>{expandedEvent === ev.id ? "▲" : "▼"}</div>
                </div>
                {expandedEvent === ev.id && (()=>{let s=ev.sessions;if(typeof s==='string')try{s=JSON.parse(s)}catch(e){s=[]};return Array.isArray(s)&&s.length>0;})() && (
                  <div style={{ marginTop: 16, borderTop: `1px solid rgba(6,78,59,0.12)`, paddingTop: 16 }}>
                    {(()=>{let s=ev.sessions;if(typeof s==='string')try{s=JSON.parse(s)}catch(e){s=[]};return Array.isArray(s)?s:[];})().map((s, i) => (
                      <div key={i} style={{ fontSize: 13, color: "#666", marginBottom: 6 }}>
                        {s.date && <span style={{ color: DG, marginRight: 8 }}>{s.date}</span>}
                        {s.title_zh || s.title || ""}
                        {s.time && <span style={{ color: "#aaa", marginLeft: 8 }}>{s.time}</span>}
                      </div>
                    ))}
                    {ev.subtitle_zh && (
                      <div style={{ fontSize: 13, color: "#888", marginTop: 12, fontStyle: "italic" }}>{ev.subtitle_zh}</div>
                    )}
                  </div>
                )}
              </div>
            ))}
            <div style={{ textAlign: "center", marginTop: 8 }}>
              <button
                onClick={() => setPage && setPage("events")}
                style={{ background: "none", border: `1px solid ${DG}`, color: DG, borderRadius: 8, padding: "8px 24px", fontSize: 13, letterSpacing: 1, cursor: "pointer" }}
              >查看全部法会 →</button>
            </div>
          </div>
        )}

        {/* Footer */}
        <div style={{ textAlign: "center", marginTop: 60, paddingTop: 32, borderTop: "1px solid rgba(0,0,0,0.06)", fontSize: 12, color: "#bbb", lineHeight: 2 }}>
          <div>法道社群 · lumarcai.com/community</div>
          <div>如有询问请联系：<a href="mailto:canada.btf@gmail.com" style={{ color: DR }}>canada.btf@gmail.com</a></div>
        </div>

      </div>
    </div>
  );
}
